import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AspProductDetailsService } from '../asp-product-details/asp-product-details.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AspClutchKitDetailsService } from './asp-clutch-kit-details.service';
import { MatDialog } from '@angular/material/dialog';
import { AspConfirmOrderPopupComponent } from '../asp-confirm-order-popup/asp-confirm-order-popup.component';

@Component({
  selector: 'app-asp-clutch-kit-details',
  templateUrl: './asp-clutch-kit-details.component.html',
  styleUrls: ['./asp-clutch-kit-details.component.scss']
})
export class AspClutchKitDetailsComponent implements OnInit {

  type: string;
  id: string;
  totalPrice: number = 0;
  showPopup = false;
  defaultImage: string = 'assets/images/logos/logo.png';
  assignedWarehouseStock = 0;
  hasStockInAssigned: boolean = false;
  hasStockInOther: boolean = false;
  noStockAnywhere: boolean = false;
  isSingleKit: boolean = false;
  isSplitKit: boolean = false;
  isFullKit: boolean = false;
  compatability: any[] = [];
  showAllMap: { [key: string]: boolean } = {};
  vehicles: any[] = [];
  isMobile: boolean = false;
  clutchList: any[] = [];
  showEmptyState: boolean = false;
  orderCreateData: any;
  warehouseStock: any[] = [];
  assignedWarehouseName: string = '';
  selectedItem: any;
  constructor(
    private route: ActivatedRoute,
    private clutchKitService: AspClutchKitDetailsService,
    private aspLoadingService: AspLoadingService,
    private aspProductDetailsService: AspProductDetailsService,
    private dialog: MatDialog  
  ) {}

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.id = params.get('id');
    });

    console.log("🚀 Clutch Page Loaded");
    console.log("Route Params:", { type: this.type, id: this.id });

    this.getClutchKitDetails();
  }

  getClutchKitDetails() {

    const garageKey = localStorage.getItem('garageKey');
    const regNo = localStorage.getItem('registrationNumber');

    console.log('📦 API Inputs:', { garageKey, regNo });

    this.aspLoadingService.show();

    this.clutchKitService
      .getClutchSuggestions(3, 'String', 'String', garageKey, regNo)
      .subscribe(
        (res: any) => {

          console.log('🔥 FULL API RESPONSE:', res);
          const mapData = res?.data?.map;
          this.orderCreateData = res?.data?.orderCreate;

          // ✅ ONLY SUCCESS CASE
          if (res?.code === 200 && mapData && Object.keys(mapData).length > 0) {

            this.aspLoadingService.hide(); // ✅ hide ONLY here

            // 👉 your full existing logic here (no change)

          } else {
            console.warn('⏳ Not 200 / empty data → keep loading');

            // 🔁 OPTIONAL: call API again after 3 sec
            setTimeout(() => {
              this.getClutchKitDetails();
            }, 3000);
          }

          // const mapData = res?.data?.map;
          this.orderCreateData = res?.data?.orderCreate;

          if (mapData && Object.keys(mapData).length > 0) {

            let rawList: any[] = [];
            Object.keys(mapData).forEach(key => {
              const items = mapData[key] || [];
              rawList = [...rawList, ...items];
            });

            console.log('📦 Raw List:', rawList);

            // ✅ MAP DATA
            this.clutchList = rawList.map(item => {

              const partInfo = item?.partInfo || {};
              const warehouse = item?.warehouseInfo?.[0]?.warehouses?.[0] || {}; // ✅ FIXED
              const zoho = item?.zohoPartPrice?.[0] || {};
              let images: string[] = [];
              if (partInfo?.productImageUrl) {
                images.push(partInfo.productImageUrl + '?v=' + new Date().getTime());
              } else {
                images.push(this.defaultImage);
              }
              let mrp = null;
              let sellingPrice = null;
              let saveAmount = null;
              let discount = null;

              if (zoho?.rate) {
                mrp = zoho.rate;
                discount = zoho?.discount || 0;
                sellingPrice = mrp - (mrp * discount / 100);
                saveAmount = mrp * discount / 100;
              } else if (partInfo?.mrp) {
                mrp = partInfo.mrp / 100;
                sellingPrice = mrp;
                saveAmount = 0;
                discount = null;
              }

              return {
                partName: partInfo?.partName || null,
                partNumber: partInfo?.partNumber || null,
                brand: partInfo?.brand || null,
                partType: partInfo?.partType || null,
                category: partInfo?.partCategory || null,
                sellingPrice,
                mrp,
                discount,
                saveAmount,
                // image: partInfo?.productImageUrl || null,
                image: partInfo?.productImageUrl
                ? partInfo.productImageUrl + '?v=' + new Date().getTime()
                : this.defaultImage,
                warehouseName: warehouse?.warehouse_name || null,
                warehouseId: warehouse?.warehouse_id || null,
                images: images,
                raw: item
              };
            });

            console.log('📋 Final Clutch List:', this.clutchList);
            // ✅ FIX: Move bad images (like drivetrain) to last
            this.clutchList.sort((a, b) => {
              const isBadA = a.image?.includes('categories');
              const isBadB = b.image?.includes('categories');

              return Number(isBadA) - Number(isBadB);
            });
            this.selectedItem = this.clutchList[0];
                    if (!this.selectedItem?.image) {
          this.selectedItem.image = this.defaultImage;
        }
            this.totalPrice = this.clutchList.reduce((sum, item) => {
              return sum + (item?.sellingPrice || 0);
            }, 0);

            // 👉 Get all warehouses from response
            const allWarehouses = [];

            this.clutchList.forEach(item => {
              const warehouses = item?.raw?.warehouseInfo?.[0]?.warehouses || [];

              warehouses.forEach(w => {
                const existing = allWarehouses.find(x => x.warehouseId === w.warehouse_id);

                if (existing) {
                  existing.stock += (w.quantity_available_for_sale || 0);
                } else {
                  allWarehouses.push({
                    name: w.warehouse_name,
                    stock: w.quantity_available_for_sale || 0,
                    warehouseId: w.warehouse_id
                  });
                }
              });
            });

            // 👉 Find assigned warehouse (from API)
            const assignedId = this.orderCreateData?.wareHouseId;
            // const assigned = allWarehouses.find( w => String(w.warehouseId) === String(assignedId));
            const assigned = allWarehouses.find(
                w => Number(w.warehouseId) === Number(assignedId)
              );

            // ✅ FINAL VALUES FOR UI
            this.assignedWarehouseStock = assigned?.stock || 0;
            this.assignedWarehouseName = assigned?.name || 'Assigned Warehouse';
            // 👉 Save full list for UI
            this.warehouseStock = allWarehouses;
            // ✅ FIX STOCK FLAGS
            this.hasStockInAssigned = this.assignedWarehouseStock > 0;

            this.hasStockInOther = this.warehouseStock.some(
              w => w.stock > 0 && String(w.warehouseId) !== String(assignedId)
            );

            this.noStockAnywhere =
              !this.hasStockInAssigned && !this.hasStockInOther;
            console.log('🏬 Warehouse List:', this.warehouseStock);
            console.log('⭐ Assigned Stock:', this.assignedWarehouseStock);
            console.log('💰 Total Price:', this.totalPrice);

            const names = this.clutchList.map(x => (x.partName || '').toLowerCase());
            const count = this.clutchList.length;
              this.isFullKit = count >= 3;
              this.isSplitKit = count === 2;
              this.isSingleKit = count === 1;

              console.log('🧠 UI Mode:', {
                isSingleKit: this.isSingleKit,
                isSplitKit: this.isSplitKit,
                isFullKit: this.isFullKit
              });

            console.log('🧠 isFullKit:', this.isFullKit);

            // =========================

            const partNumber = this.clutchList[0]?.partNumber;

            if (partNumber) {
              this.getCompatability(partNumber);
            } else {
              console.warn('⚠️ Part number missing');
              this.showEmptyState = true;
            }

          } else {
            console.warn('⚠️ No clutch data found');
            this.showEmptyState = true;
          }
        },
        err => {
          this.aspLoadingService.hide();
          console.error('❌ API ERROR:', err);
          this.showEmptyState = true;
        }
      );
  }

  getCompatability(partNumber: string) {

    console.log("📡 Calling Compatibility API with:", partNumber);

    this.aspLoadingService.show();

    this.aspProductDetailsService
      .getProductCompatability(partNumber)
      .subscribe(result => {

        let res = JSON.parse(JSON.stringify(result));
        this.aspLoadingService.hide();

        console.log("🚗 Compatibility API Response:", res);

        this.compatability = [];

        if (!res?.data?.vehicle?.length) {
          console.warn("⚠️ No compatibility data");
          return;
        }

        res.data.vehicle.forEach(vehicle => {

          let data = [];

          vehicle.models.forEach(model => {

            let rowKey = model.rowKey;
            let modelName = model.model;

            res.data.variants[rowKey]?.forEach(list => {
              list.model = modelName;
              data.push(list);
            });

          });

          this.compatability.push([vehicle.name, data]);
          this.showAllMap[vehicle.name] = false;
          this.vehicles = vehicle.models.length;
        });

        console.log("✅ FINAL Compatibility Data:", this.compatability);
      });
  }

  // =========================
  // UI HELPERS
  // =========================
  getVisibleModels(models: any[], vehicleName: string): any[] {
    return this.showAllMap[vehicleName] ? models : models.slice(0, 10);
  }

  toggleShowMore(vehicleName: string) {
    this.showAllMap[vehicleName] = !this.showAllMap[vehicleName];
  }

  // =========================
  // POPUP
  // =========================
  checkAvailability() {
    this.showPopup = true;
    this.evaluateStock();
  }

  closePopup() {
    this.showPopup = false;
  }

  // =========================
  // STOCK LOGIC
  // =========================
  evaluateStock() {

    const warehouseStock = this.clutchList?.[0]?.warehouseStock || [];
    const zone = localStorage.getItem("zone") || '';

    let assigned = warehouseStock.find(w => w.name === zone);

    this.assignedWarehouseStock = assigned?.stock || 0;

    this.hasStockInAssigned = this.assignedWarehouseStock > 0;

    this.hasStockInOther = warehouseStock.some(w => w.stock > 0);

    this.noStockAnywhere =
      !this.hasStockInAssigned && !this.hasStockInOther;
  }
 onAddToCart() {

    if (!this.orderCreateData) {
      console.warn('⚠️ No order data found');
      return;
    }

    const payload = {
      orderCreate: this.orderCreateData
    };

    this.aspLoadingService.show();

    this.clutchKitService.instantOrder(payload)
      .subscribe(
        (res: any) => {
          this.aspLoadingService.hide();

          console.log('✅ Order Created:', res);

          // ✅ IMPORTANT: store order for popup (your popup reads from sessionStorage)
          sessionStorage.setItem('order', JSON.stringify(res?.data));

          // ✅ OPEN POPUP
          this.dialog.open(AspConfirmOrderPopupComponent, {
            width: '400px',
            panelClass: 'custom-dialog-container',
            disableClose: true
          });

        },
        err => {
          this.aspLoadingService.hide();
          console.error('❌ Order API Error:', err);
        }
      );
  }
  onImageError(event: any) {
    event.target.src = this.defaultImage;
    event.target.onerror = null; // 🔥 prevents infinite loop
  }
  selectItem(item: any) {
    this.selectedItem = item;
  }
  onScroll() {
    console.log('Scrolling...');
  }
}